module.exports = __webpack_public_path__ + "img/music_video.c37a146d.svg";